import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UtilityService } from '../../../services/utility-service';
import { ArrayOfKeys } from '../../../model/ArrayOfKeys';
import { ApiService } from '../../../services/api.service';
import { SearchUpdateModelVO } from '../../../model/searchUpdateModelVO';
import { Constants } from '../../../constants/ebtq-constants';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import {Title} from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-search-update-loan-form',
  templateUrl: './search-update-loan-form.component.html',
  styleUrls: ['./search-update-loan-form.component.scss']
})
export class SearchUpdateLoanFormComponent implements OnInit, OnDestroy {

  private errorSub: Subscription;
  warningMessage: string;
  errorMessage: string[] = [];
  sortOrder: any[];
  productCode: any[];
  loanStatus: any[];
  isLoading: boolean;
  selNumber: any[];
  serNumber: any[];
  title = 'Search and Update Loans';


  service: ApiService;
  searchModel: SearchUpdateModelVO;
  utilService: UtilityService;
  router: Router;

  containsError = false;
  errorMsg: string;
  isExternal: boolean;

  searchForm = new UntypedFormGroup({
    sellerrNumber: new UntypedFormControl(''),
    servicerNumber: new UntypedFormControl(''),
    ContractNumber: new UntypedFormControl(''),
    lenderLoanNumber: new UntypedFormControl(''),
    fnmeLoanNumber: new UntypedFormControl(''),
    loanStatus: new UntypedFormControl(''),
    PurchaseFromDt: new UntypedFormControl(''),
    PurchaseToDt: new UntypedFormControl(''),
    ProductCd: new UntypedFormControl(''),
    userID: new UntypedFormControl(''),
    SortOrder: new UntypedFormControl('')
  });

  constructor(apiService: ApiService,
    router: Router, private errorService: ErrorService, private formBuilder: UntypedFormBuilder, private titleService: Title,
              private cdr: ChangeDetectorRef) {

    this.router = router;
    this.searchModel = new SearchUpdateModelVO();
    this.service = apiService;
    this.utilService = new UtilityService();

    this.loanStatus = [];
    this.loanStatus = this.utilService.loanStatus;
    this.productCode = [];
    this.productCode = this.utilService.productCode;
    this.sortOrder = [];
    this.sortOrder = this.utilService.sortOrder;

  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.warningMessage = '';
    // this.searchForm.reset();

    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (this.isExternal == null) ? false : this.isExternal;
    sessionStorage.setItem('currentSubMenuOption', 'RMAcquisitions');

    this.selNumber = [];
    this.serNumber = [];

    if (this.isExternal) {
      if (sessionStorage.getItem('authServrList') != null) {
        const authServrList = JSON.parse(sessionStorage.getItem('authServrList'));
        this.serNumber.push({label: 'ALL', value: 'ALL'});
        for (let i = 0; i < authServrList.length; i++) {
          this.serNumber.push(authServrList[i]);
        }
        this.searchForm.controls.servicerNumber.setValue(this.serNumber[0].value);

      } else {
        this.containsError = true;
        this.errorMsg = 'There is some problem with the server to load.. Please try again later!';
      }

      if (sessionStorage.getItem('sellerList') != null) {
        this.selNumber = Array.from(JSON.parse(sessionStorage.getItem('sellerList')));
        this.searchForm.controls.sellerrNumber.setValue(this.selNumber[0].value);

      } else {
        this.containsError = true;
        this.errorMsg = 'There is some problem with the server to load.. Please try again later!';
      }

    }
  }

  onClear(): void {

    this.searchForm.reset();
    this.errorMessage = [];
    this.warningMessage = '';
  }

  public queryLoanDetails(): void {

    this.warningMessage = '';
    this.errorMessage = [];


    let arrayOfkeys: ArrayOfKeys;

    this.searchModel.queryMap = this.searchForm.value;

    /** Converting date format to mm/dd/yyy */
    if (this.searchModel.queryMap.PurchaseToDt != null && this.searchModel.queryMap.PurchaseToDt !== '') {
      this.searchModel.queryMap.PurchaseToDt = this.utilService.convertMillisecToDate(this.searchModel.queryMap.PurchaseToDt);
    }
    if (this.searchModel.queryMap.PurchaseFromDt != null && this.searchModel.queryMap.PurchaseFromDt !== '') {
      this.searchModel.queryMap.PurchaseFromDt = this.utilService.convertMillisecToDate(this.searchModel.queryMap.PurchaseFromDt);
    }
    if (this.searchModel.queryMap.fnmeLoanNumber !== '' && this.searchModel.queryMap.fnmeLoanNumber != null) {
      this.searchModel.queryMap.fnmeLoanNumber = '6000' + this.searchModel.queryMap.fnmeLoanNumber;
    }

    // if the servicer number is selected as ALL then do not send anything to backend
    if (this.searchModel.queryMap.servicerNumber === 'ALL') {
      this.searchModel.queryMap.servicerNumber = '';
    }

    /** validate search form data */
    this.errorMessage = this.validateForm(this.searchModel);

    /** When there is validation message , it stop here */
    if (this.errorMessage.length > 0) {
      return;
    }
    /** Requesting matching loan id */
    this.service.searchUpdateLoan(this.searchModel).subscribe(
      (data: Array<any>) => {
        if (data.length === 0) {
          this.warningMessage = Constants.No_LOAN_FUND_MSG;
          this.cdr.detectChanges();
          return;
        }
        if (data.length > 500) {
          this.warningMessage = Constants.RESULT_WARNING;
          this.cdr.detectChanges();
          return;
        }
        arrayOfkeys = new ArrayOfKeys();
        arrayOfkeys.keys = data;

        /** Routing to result page when there are matching records. passing list of matching keys to get results */
        this.router.navigate(['searchResult'], {
          queryParams: { query: btoa(JSON.stringify(arrayOfkeys.keys)) }
        });

      },
      error => {
        this.errorService.announceError(error);
      }
    );

    this.errorAnnouncement();
  }

  errorAnnouncement() {
    // error announcement
    this.errorSub = this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    if (this.errorSub) {
      this.errorSub.unsubscribe();
    }
  }

  /**  Validate FormModel according to business needs, return possible error to user*/
  private validateForm(searchModel: SearchUpdateModelVO): string[] {
    const errorMessages: string[] = [];

    /** Seller Number Validation */
    const sellerNumber = searchModel.queryMap.sellerrNumber;
    const sellerNumberDigit = /^\d+$/.test(searchModel.queryMap.sellerrNumber);
    if (sellerNumber !== '' && sellerNumber != null) {
      if (sellerNumber.length < 9 || sellerNumberDigit !== true) {
        errorMessages.push(Constants.SELLER_VALIDATION);
      }
    }

    /** Servicer Number Validation */
    const servicerNumber = searchModel.queryMap.servicerNumber;
    const servicerNumberDigit = /^\d+$/.test(searchModel.queryMap.servicerNumber);
    if (servicerNumber !== '' && servicerNumber != null) {
      if (servicerNumber.length < 9 || servicerNumberDigit !== true) {
        errorMessages.push(Constants.SERVICER_VALIDATION);
      }
    }
    /** Contract Number Validation */
    const contractNumber = searchModel.queryMap.ContractNumber;
    const contractNumberDigit = /^\d+$/.test(searchModel.queryMap.ContractNumber);
    if (contractNumber !== '' && contractNumber != null) {
      if (contractNumber.length < 6 || contractNumberDigit !== true) {
        errorMessages.push(Constants.CONTRACT_VALIDATION);
      }
    }
    /** Lender Loan Number Validation */
    const lenderLoanNumber = searchModel.queryMap.lenderLoanNumber;
    const lenderLoanNumberDigit = /^\d+$/.test(searchModel.queryMap.lenderLoanNumber);
    if (lenderLoanNumber !== '' && lenderLoanNumber != null) {
      if (lenderLoanNumber.length > 15 || lenderLoanNumberDigit !== true) {
        errorMessages.push(Constants.LENDERLOAN_VALIDATION);
      }
    }

    /** FNME Loan Number Validation */
    const fnmeLoanNumber = searchModel.queryMap.fnmeLoanNumber;
    const fnmeLoanNumberDigit = /^\d+$/.test(searchModel.queryMap.fnmeLoanNumber);
    if (fnmeLoanNumber !== '' && fnmeLoanNumber != null) {
      if (fnmeLoanNumber.length < 10 || fnmeLoanNumberDigit !== true) {
        errorMessages.push(Constants.LOANNUMBER_VALIDATION);
      }
    }

    /** User ID  Validation */
    const userID = searchModel.queryMap.userID;
    if (userID !== '' && userID != null) {
      if (this.utilService.isContainIllegalChar(userID) === true) {
        errorMessages.push(Constants.USERID_VALIDATION);
      }
    }

    /** Loan Status Validation */
    const status = searchModel.queryMap.status;

    if (status !== '' && status != null) {
      if (this.utilService.isContainIllegalChar(status) === true) {
        errorMessages.push(Constants.STATUS_VALIDATION);
      }
    }
    return errorMessages;
  }


}
